export enum GroupMemberAffiliationStatusEnum {
    INTERNAL = 0,
    EXTERNAL,
    YXADMIN,
}
